export const TOOLTIP_TEXT = {
  DEFAULT: 'Hold Shift and drag to select multiple vessels',
  ON_HOVER_VESSEL: 'Click a vessel to see more details',
};

export const APP_VERSION = process.env.REACT_APP_VERSION_NAME || 'dev';
